import _ from 'lodash';
import type uPlot from 'uplot';

import {type FacetData, type FacetedData} from './getFacetedData';

/**
 * Find the first and last points within the chart's visible X range.
 * The line's X values must be sorted from smallest to largest; points exactly
 * at the minimum or maximum X value are included. A missing limit leaves that
 * side unrestricted. If no points are visible, the first index exceeds the last.
 * Each line has its own X values, so we find its visible points separately.
 */
export function getFacetWindow(
  xs: number[],
  min: number | null | undefined,
  max: number | null | undefined
): [idx0: number, idx1: number] {
  // Keep the existing handling of an invalid X limit (NaN): an invalid minimum
  // includes the start of the line; an invalid maximum leaves no visible points.
  return [
    min == null || Number.isNaN(min) ? 0 : _.sortedIndex(xs, min),
    max == null
      ? xs.length - 1
      : Number.isNaN(max)
        ? -1
        : _.sortedLastIndex(xs, max) - 1,
  ];
}

/**
 * Read one line's X and Y values from the chart. For a min/max band, this reads
 * one of its two edges. The cast is needed because uPlot's types describe only
 * charts where all lines share the same X values.
 */
export function getFacetData(u: uPlot, seriesIdx: number): FacetData {
  return (u.data as unknown as FacetedData)[seriesIdx] as FacetData;
}
